import { useWatch } from '@graphcommerce/ecommerce-ui'
import { getProductTierPrice, useFormAddProductsToCart } from '@graphcommerce/magento-product'
import { ConfigurableOptionsFragment } from '@graphcommerce/magento-product-configurable/graphql/ConfigurableOptions.gql'
import { useConfigurableOptionsSelection } from '@graphcommerce/magento-product-configurable/hooks/useConfigurableOptionsSelection'
import { Money } from '@graphcommerce/magento-store'

type ConfigurablePriceProps = {
  product: ConfigurableOptionsFragment
  index?: number
}

export function CustomConfigurablePrice(props: ConfigurablePriceProps) {
  const { product, index = 0 } = props
  const { configured, loading } = useConfigurableOptionsSelection({
    url_key: product.url_key,
    index,
  })
  console.log({ loading })
  const { control } = useFormAddProductsToCart()
  const quantity = useWatch({ control, name: `cartItems.${index}.quantity` })

  const regular_price =
    configured?.configurable_product_options_selection?.variant?.price_range.minimum_price
      .final_price ?? product.price_range?.minimum_price.final_price

  const price_tiers = configured?.configurable_product_options_selection?.variant?.price_tiers
  const price = getProductTierPrice({ price_tiers }, quantity) ?? regular_price

  return (
    <div style={{ opacity: loading ? 0.6 : 1 }}>
      <Money currency={price?.currency} value={price?.value ? price?.value * (quantity ?? 1) : 0} />
      {loading && <span className='loader' />}
    </div>
  )
}
